/**
 * Stand-ins for the Gravity Forms functions its markup calls inline.
 *
 * The theme loads none of Gravity Forms' scripts, but its fields still carry
 * `onchange="gformToggleRadioOther( this )"` and the submit buttons
 * `onclick="gform.submission.handleButtonClick( this )"`. Without these, every
 * radio click and submit logs an error.
 */
( function() {
	/**
	 * Turn the "Other" box of a radio field on when its choice is picked.
	 *
	 * @param {HTMLInputElement} radio The radio button that changed.
	 */
	window.gformToggleRadioOther = window.gformToggleRadioOther || function( radio ) {
		const container = radio.closest( '.ginput_container_radio' );
		const other = container && container.querySelector( '.gchoice_other_control' );

		if ( ! other ) {
			return;
		}

		other.disabled = 'gf_other_choice' !== radio.value;

		if ( ! other.disabled ) {
			other.focus();
		}
	};

	// The button submits the form on its own; there is nothing to add.
	window.gform = window.gform || {};
	window.gform.submission = window.gform.submission || { handleButtonClick: function() {} };
}() );

/**
 * Grows textareas to fit their content where `field-sizing` is unsupported.
 */
( function() {
	if ( window.CSS && CSS.supports && CSS.supports( 'field-sizing', 'content' ) ) {
		return;
	}

	const areas = document.querySelectorAll( '.form-field textarea' );

	if ( ! areas.length ) {
		return;
	}

	/**
	 * Match the box to its contents.
	 *
	 * @param {HTMLTextAreaElement} area The field to size.
	 */
	function fit( area ) {
		area.style.height = 'auto';
		area.style.height = area.scrollHeight + 'px';
	}

	areas.forEach( function( area ) {
		area.removeAttribute( 'rows' );

		fit( area );
		area.addEventListener( 'input', function() {
			fit( area );
		} );
	} );
}() );

/**
 * Keeps the submit button shimmering while the form posts, and stops a second click sending it twice.
 */
( function() {
	document.addEventListener( 'submit', function( event ) {
		const form = event.target;

		// Stopped already, by a step that is not answered (form-steps.js).
		if ( event.defaultPrevented || ! form.closest( '.gform_wrapper' ) ) {
			return;
		}

		if ( form.dataset.submitting ) {
			event.preventDefault();
			return;
		}

		form.dataset.submitting = 'true';

		const button = event.submitter && event.submitter.closest( '.shimmer' );

		if ( button ) {
			button.setAttribute( 'aria-busy', 'true' );
		}
	} );

	// Coming back through the history cache brings the page back mid-send; let it go again.
	window.addEventListener( 'pageshow', function( event ) {
		if ( ! event.persisted ) {
			return;
		}

		document.querySelectorAll( '.gform_wrapper form[data-submitting]' ).forEach( function( form ) {
			delete form.dataset.submitting;
		} );

		document.querySelectorAll( '.gform_wrapper .shimmer[aria-busy]' ).forEach( function( button ) {
			button.removeAttribute( 'aria-busy' );
		} );
	} );
}() );
